import { assign, entryId, restoreSequence } from "../../helper.js";
import { isBoolean, isNil, isPlainObject, isString } from "es-toolkit";
//#region ../erd-editor-schema/dist/v3/parser/index.entity.js
var createIndex = () => ({
	id: "",
	name: "",
	tableId: "",
	indexColumnIds: [],
	seqIndexColumnIds: [],
	unique: false
});
function createAndMergeIndexEntities(json) {
	const entities = {};
	if (!isPlainObject(json) || isNil(json)) return entities;
	for (const [key, value] of Object.entries(json)) {
		if (!isPlainObject(value)) continue;
		const target = createIndex();
		const assignString = assign(isString, target, value);
		const assignBoolean = assign(isBoolean, target, value);
		const assignArray = assign(Array.isArray, target, value);
		target.id = entryId(key, value);
		assignString("name");
		assignString("tableId");
		assignBoolean("unique");
		assignArray("indexColumnIds");
		assignArray("seqIndexColumnIds");
		target.seqIndexColumnIds = restoreSequence(target.indexColumnIds, target.seqIndexColumnIds);
		if (target.id) entities[target.id] = target;
	}
	return entities;
}
//#endregion
export { createAndMergeIndexEntities, createIndex };
